import { createSlice } from "@reduxjs/toolkit";

// Get from localStorage or fallback to default value 'prod'
const initialModule = localStorage.getItem("moduleView") || "prod";

const moduleChangeSlice = createSlice({
  name: "moduleView",
  initialState: initialModule,
  reducers: {
    setChangeModule: (state, action) => {
      localStorage.setItem("moduleView", action.payload); // Save to localStorage
      return action.payload;
    },
  },
});

export const { setChangeModule } = moduleChangeSlice.actions;
export default moduleChangeSlice.reducer;
